const getButtonHandler = (evt) => {
  evt.preventDefault();

  window.location.pathname = '/personal/order/';
};

const init = () => {
  const getOrderButton = document.querySelector('[data-entity="basket-checkout-button"]');

  if (getOrderButton && !getOrderButton.classList.contains('_init')) {
    getOrderButton.addEventListener('click', getButtonHandler);
    getOrderButton.classList.add('_init');
  }
};

init();

window.initBasketGetOffer = init;
